<template>
  <div class="min-h-screen bg-[#14151A] flex items-center justify-center px-4">
    <div class="max-w-md w-full text-center">
      <h1 class="text-3xl font-bold text-white mb-8 font-Almarai">
        اختبار الكوبونات
      </h1>
      
      <div class="space-y-4">
        <button
          @click="openCouponModal"
          class="w-full bg-[#9d2890] hover:bg-[#8a2279] text-white font-semibold py-4 px-6 rounded-xl transition-colors duration-200 font-Almarai"
        >
          فتح نافذة الكوبون
        </button>
        
        <div class="bg-gray-800 rounded-lg p-4 text-right">
          <h3 class="text-white font-semibold mb-2 font-Almarai">كوبونات للاختبار:</h3>
          <ul class="text-gray-300 text-sm space-y-1 font-Almarai">
            <li>• Nasna2025 (صالح)</li>
            <li>• DISCOUNT20 (صالح)</li>
            <li>• WELCOME (صالح)</li>
            <li>• INVALID123 (غير صالح)</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CouponDemo",
  methods: {
    openCouponModal() {
      this.$router.push({ name: 'coupon.redeem' });
    }
  }
};
</script>

<style scoped>
button:hover {
  transform: translateY(-1px);
}

button:active {
  transform: translateY(0);
}

button {
  transition: all 0.2s ease-in-out;
}
</style>